/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */



import RoutesMeta from './routes.json'
import Notifications from './utils/Notifications';
import InformationContainerItem from './types/elements/InformationContainerItem';

import SocialMediaItemProps from './types/elements/SocialMediaItem';
import TikTokImage from './assets/images/pages/home/social-media/tiktok.png';
import InstagramImage from './assets/images/pages/home/social-media/instagram.png';
import YouTubeImage from './assets/images/pages/home/social-media/youtube.png';

const IS_DEBUG = process.env.NODE_ENV === 'development'

const LayoutBreakpoints = {
    mobile: 480,
    tablet: 768,
    desktop: 1048,
    huge: 1920,
}

const SocialMediaLinks = {
    tiktok: 'https://www.tiktok.com/@komedispflegezeitarbeit',
    instagram: 'https://www.instagram.com/komedis_de/?hl=de',
    youtube: 'https://www.youtube.com/@komedisPflege'
};

const SocialMediaItems: SocialMediaItemProps[] = [
    {
        title: 'Tiktok',
        url: SocialMediaLinks.tiktok,
        imageUrl: TikTokImage
    },
    {
        title: 'Instagram',
        url: SocialMediaLinks.instagram,
        imageUrl: InstagramImage
    },
    {
        title: 'YouTube',
        url: SocialMediaLinks.youtube,
        imageUrl: YouTubeImage
    }
]

const SITE_DOMAIN = (process.env.REACT_APP_SITE_DOMAIN ?? '');
const API_DOMAIN = (process.env.REACT_APP_API_DOMAIN ?? '');

const BlogArticleRouteSlug = RoutesMeta.blogArticle.path;

const Constants = {
    COMPANY_NAME: (process.env.REACT_APP_COMPANY_NAME ?? ''),
    SITE_NAME: (process.env.REACT_APP_SITE_NAME ?? ''),
    SITE_DOMAIN,
    SITE_URL: 'https://' + SITE_DOMAIN,
    API_DOMAIN,
    API_URL: 'https://' + API_DOMAIN,

    isDebug: IS_DEBUG,
    RoutesMeta,
    BlogArticleRouteSlug,
    SocialMediaLinks,
    SocialMediaItems,
    LayoutBreakpoints,
    handleException: (exception: any) => {
        Notifications.error(typeof exception === 'string' ? exception : 'Ein Fehler ist aufgetreten')
        Constants.logException(exception)
    },
    logException: (exception: any) => {
        console.error('Exception:', exception)
        if (IS_DEBUG) {
            alert('Exception: ' + exception)
        }
    },
    logMessage: (message: string) => {
        if (IS_DEBUG) {
            console.log('Message:', message)
        }
    },
    getBaseUrl: (dropQuery: boolean = false): string => {
        // @ts-expect-error ignore type hint
        return global.getBaseUrl(dropQuery)
    },
    getWindowWidth: (): number => {
        // @ts-expect-error ignore type hint
        return global.getWindowWidth()
    },
    isLoaderEnabled: (): boolean  => {
        // @ts-expect-error ignore type hint
        return window.isLoaderEnabled;
    },
    setLoaderEnabled: (enabled: boolean): void => {
        // @ts-expect-error ignore type hint
        window.isLoaderEnabled = enabled;
    },
    setHeaderImage: (image: JSX.Element): void => {
        // @ts-expect-error ignore type hint
        global.setHeaderImage(image);
    },
    setInformationContainerItem: (item: InformationContainerItem): void => {
        // @ts-expect-error ignore type hint
      global.setInformationContainerItem(item);
    },
    // execute DOM-modifying function without showing loader
    executeWithoutLoader: (
        exec: ((...args: any) => void),
        waitMillisecondsExecute: number = 10,
        waitMillisecondsEnable: number = 20,
        ...args: any
    ): void => {
        Constants.setLoaderEnabled(false);
        setTimeout(() => exec(...args), waitMillisecondsExecute);
        setTimeout(() => Constants.setLoaderEnabled(true), waitMillisecondsEnable);
    },
    isLoading: (): boolean => {
        // @ts-expect-error ignore type hint
        return window.isLoading
    },
    setLoading: (loading: boolean) => {
        // @ts-expect-error ignore type hint
        window.isLoading = loading
        // @ts-expect-error ignore type hint
        if (typeof window.showLoaderNow === 'function') {
            // @ts-expect-error ignore type hint
            window.showLoaderNow(loading);
        }
    },
    scrollToTop: (smooth = false) => {
        const header = document.getElementById('header');
        if (header) {
            header.scrollIntoView(smooth ? { behavior: 'smooth' } : true);
        }
    }
}

export default Constants
